import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./CookieConsent.css";

const STORAGE_KEY = "gemfashion_cookie_consent";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      const timer = setTimeout(() => setIsVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const close = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  const handleAcceptAll = () => {
    localStorage.setItem(STORAGE_KEY, "accept_all");
    close();
  };

  const handleSettings = () => {
    localStorage.setItem(STORAGE_KEY, "settings");
    close();
  };

  const handleLinkClick = () => {
    localStorage.setItem(STORAGE_KEY, "viewed_notice");
  };

  if (!isVisible) return null;

  return (
    <div
      className={`cookie-consent ${isClosing ? "cookie-consent--closing" : ""}`}
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="cookie-consent__inner">
        <h2 id="cookie-consent-title" className="cookie-consent__title">
          Before you start renting
        </h2>
        <div id="cookie-consent-desc" className="cookie-consent__content">
          <p>
            Gem Fashion Studios uses first- and third-party cookies and similar
            technologies so our site works properly, to personalise your
            experience, to understand how you use our rental service, and to show
            you relevant content and ads (including on other sites). We may also
            collect information about your device and how you browse to improve
            our service and your experience.
          </p>
          <p>
            By clicking &ldquo;Accept all&rdquo;, you agree we can share your
            information with our advertising partners. If you choose
            &ldquo;Only required cookies&rdquo;, we will not use optional
            cookies and you may see less tailored content. Click
            &ldquo;Cookies and services settings&rdquo; to choose your options,
            or read our{" "}
            <Link
              to="/cookie-policy"
              className="cookie-consent__link"
              onClick={handleLinkClick}
            >
              Cookie and data sharing notice
            </Link>{" "}
            to learn more.
          </p>
        </div>
        <div className="cookie-consent__actions">
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--primary"
            onClick={handleAcceptAll}
          >
            Accept all
          </button>
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--secondary"
            onClick={handleSettings}
          >
            Cookies and services settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
